import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { from } from 'rxjs';
import { PendoEffects } from './pendo/pendo.effects';
import * as fromPendo from './pendo/pendo.reducer';
import * as fromCommon from './common/common.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot({}),
    StoreModule.forFeature(fromPendo.pendoFeatureKey, fromPendo.reducer),
    StoreModule.forFeature(fromCommon.commonFeatureKey, fromCommon.commonReducer),
  ],
})
export class PatientHelpCenterModule {}
